import { useId } from 'react'
import type { ReviewDraft, ScreenSection } from '../types/photo'
import { lateralFields } from '../lib/photoReview'
import { ClubInput, ReviewCellInput } from './ScreenReviewGrid'
import { inputClass } from './ui'

export default function SummaryReviewForm({ section, draft, labels, onChange }: {
  section: ScreenSection; draft: ReviewDraft; labels: Record<string, string>; onChange: (draft: ReviewDraft) => void
}) {
  const id = useId()
  const row = draft.rows[0]
  const source = section.summary!
  return <div className="rounded-lg border border-line bg-surface p-5">
    <h3 className="font-serif text-2xl">Averages from the screen</h3>
    <p className="mt-2 text-sm leading-6 text-muted">These are averages, not individual shots. They won’t create a shot table or dispersion chart.</p>
    <div className="mt-5 grid gap-5 sm:grid-cols-2">
      <div><p className="mb-2 text-sm font-medium">Club</p><ClubInput row={row} source={source} label="Summary club" onChange={next => onChange({ ...draft, rows: [next] })} /></div>
      <div><label htmlFor={id} className="mb-2 block text-sm font-medium">Shots reported (optional)</label><input id={id} className={inputClass} inputMode="numeric" maxLength={3} value={draft.shotsReported.text}
        aria-invalid={!draft.shotsReported.resolved} aria-describedby={source.flags.shots_reported ? `${id}-reason` : undefined}
        onChange={event => onChange({ ...draft, shotsReported: { text: event.target.value, resolved: !!event.target.value.trim() } })} />
        {source.flags.shots_reported && <p id={`${id}-reason`} className="mt-2 text-xs text-notice-ink">{source.flags.shots_reported}</p>}
        <button type="button" className="min-h-11 text-xs font-medium text-brand underline" onClick={() => onChange({ ...draft, shotsReported: { text: '', resolved: true } })}>Clear shots reported</button>
      </div>
      {Object.keys(draft.columns).filter(field => field !== 'club' && !draft.columns[field].dropped).map(field => <div key={field}>
        <p className="mb-2 text-sm font-medium">{labels[field] ?? section.fields[field].label} <span className="font-mono text-xs text-muted">({draft.columns[field].unit || 'Choose unit'})</span></p>
        <ReviewCellInput label={`Summary ${labels[field] ?? section.fields[field].label}`} cell={row.values[field]} reason={source.flags[field]} lateral={lateralFields.has(field)}
          onChange={cell => onChange({ ...draft, rows: [{ ...row, values: { ...row.values, [field]: cell } }] })} />
      </div>)}
    </div>
  </div>
}
